import React, { useEffect, useState } from "react";
import api from "../utils/axiosConfig";
import localforage from "localforage";
import Dashboard from "./Dashboard";

const API_URL = process.env.REACT_APP_API_URL;

const SUMMARY_COLS = [
  ["region", "Region"],
  ["mappedResource", "Mapped Resource"],
  ["district", "District"],
  ["dpoc", "DPOC"],
  ["acNo", "AC No"],
  ["acName", "AC Name"],
  ["priority", "Priority"],
  ["category", "Category"],
  ["acmName", "ACM Name"],
  ["totalBooth", "Total Booth"],
  ["__button", "Booth wise details"],
  ["status", "Status"],
  ["voterListReceivedAtOffice", "Voter list received at party office"],
  ["voterListDistributed", "Voter List Distributed"],
  ["casteCensusStatus", "Caste Census Status"],
  ["voterListReceived", "Voter List Received"],
  ["boothPradhanAppointed", "Booth Pradhan Appointed"],
  ["womenBoothPradhanAppointed", "Women Booth Pradhan Appointed"],
  ["scBoothPradhanAppointed", "SC Booth Pradhan Appointed"],
  ["bcBoothPradhanAppointed", "BC Booth Pradhan Appointed"],
  ["youthBoothPradhanAppointed", "Youth Booth Pradhan Appointed"],
  ["committee11Formed", "Total 11 member committee formed"],
  ["circleInchargeMapped", "Circle Incharge Mapped"],
  ["circleInchargeName", "Name of the mapped circle incharge"],
  ["boothPocName", "Name of Booth POC mapped"],
  ["remark", "Remark"],
];

const DETAIL_COLS = [
  ["acm", "ACM"], ["partNo", "Part No"], ["partName", "Part Name"],
  ["voterListReceivedAtOffice", "Voter list received at party office"],
  ["voterListDistributed", "Voter List Distributed"],
  ["casteCensusStatus", "Caste Census Status"],
  ["voterListReceived", "Voter List Received"],
  ["boothPradhanAppointed", "Booth Pradhan Appointed"],
  ["womenBoothPradhanAppointed", "Women Booth Pradhan Appointed"],
  ["scBoothPradhanAppointed", "SC Booth Pradhan Appointed"],
  ["bcBoothPradhanAppointed", "BC Booth Pradhan Appointed"],
  ["youthBoothPradhanAppointed", "Youth Booth Pradhan Appointed"],
  ["committee11Formed", "Total 11 member committee formed"],
  ["circleInchargeMapped", "Circle Incharge Mapped"],
  ["circleInchargeName", "Name of the mapped circle incharge"],
  ["boothPocName", "Name of Booth POC mapped"],
  ["remark", "Remark"],
];

const csvCell = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
};

const th = { padding: "6px 8px", textAlign: "center", verticalAlign: "middle", whiteSpace: "nowrap", border: "1px solid #14528f" };
const td = { padding: "6px 8px", textAlign: "center", verticalAlign: "middle", whiteSpace: "nowrap", border: "1px solid #bcd0e6" };

const BoothManagerView = () => {
  const [geo, setGeo] = useState({ districts: [], byDistrict: {} });
  const [district, setDistrict] = useState("");
  const [acNo, setAcNo] = useState("");
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const [detailAcNo, setDetailAcNo] = useState(null);
  const [detailLabel, setDetailLabel] = useState("");
  const [detailRows, setDetailRows] = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);

  const authHeader = async () => {
    const token = await localforage.getItem("token");
    return { Authorization: "Bearer " + token };
  };

  useEffect(() => {
    (async () => {
      try {
        const headers = await authHeader();
        const res = await api.get(`${API_URL}/booth-wise/geo`, { headers });
        setGeo(res.data || { districts: [], byDistrict: {} });
      } catch (e) { /* ignore */ }
    })();
    loadSummary("", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadSummary = async (dist, ac) => {
    setLoading(true);
    setMsg("");
    setDetailAcNo(null);
    setDetailRows([]);
    try {
      const headers = await authHeader();
      const params = {};
      if (ac) params.acNo = ac;
      else if (dist) params.district = dist;
      const res = await api.get(`${API_URL}/booth-wise/summary`, { headers, params });
      setSummary(res.data.rows || []);
      if (!res.data.rows || !res.data.rows.length) setMsg("No assemblies match the filter.");
    } catch (e) {
      setMsg(e.response?.data?.error || "Could not load summary.");
    } finally {
      setLoading(false);
    }
  };

  const getData = () => loadSummary(district, acNo);

  const openDetail = async (row) => {
    setDetailAcNo(row.acNo);
    setDetailLabel(row.acNo + " - " + row.acName);
    setDetailLoading(true);
    setDetailRows([]);
    try {
      const headers = await authHeader();
      const res = await api.get(`${API_URL}/booth-wise/manager-data`, { headers, params: { acNo: row.acNo } });
      setDetailRows(res.data.rows || []);
    } catch (e) {
      setMsg(e.response?.data?.error || "Could not load booth details.");
    } finally {
      setDetailLoading(false);
    }
  };

  const downloadSummaryCSV = () => {
    if (!summary.length) return;
    const cols = SUMMARY_COLS.filter(([k]) => k !== "__button");
    const head = cols.map(([, h]) => csvCell(h)).join(",");
    const body = summary.map((r) => cols.map(([k]) => csvCell(r[k])).join(",")).join("\n");
    const blob = new Blob([head + "\n" + body], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "booth-summary.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const resetAll = () => {
    setDistrict("");
    setAcNo("");
    setDetailAcNo(null);
    setDetailRows([]);
    setDetailLabel("");
    setMsg("");
    loadSummary("", "");
  };

  return (
    <div>
      <Dashboard />
      <div style={{ padding: "20px", maxWidth: "1600px", margin: "0 auto" }}>
        <h2 style={{ textAlign: "center" }}>Booth Data — Manager View</h2>

        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "end", justifyContent: "center", margin: "12px 0" }}>
          <div>
            <label style={{ display: "block", fontSize: "13px" }}>District</label>
            <select value={district} onChange={(e) => { setDistrict(e.target.value); setAcNo(""); }}>
              <option value="">All Districts</option>
              {geo.districts.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display: "block", fontSize: "13px" }}>Assembly (AC)</label>
            <select value={acNo} onChange={(e) => setAcNo(e.target.value)} disabled={!district}>
              <option value="">All Assemblies</option>
              {(geo.byDistrict[district] || []).map((a) => (
                <option key={a.ac_no} value={a.ac_no}>{a.ac_no} - {a.ac_name}</option>
              ))}
            </select>
          </div>
          <button type="button" onClick={getData} disabled={loading}
            style={{ background: "#1f6fd0", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 20px", fontWeight: 600, cursor: "pointer" }}>
            {loading ? "Loading..." : "Get Data"}
          </button>
          {summary.length > 0 && (
            <button type="button" onClick={downloadSummaryCSV}
              style={{ background: "#166534", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 20px", fontWeight: 600, cursor: "pointer" }}>
              Download Excel (CSV)
            </button>
          )}
          <button type="button" onClick={resetAll}
            style={{ background: "#374151", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 20px", fontWeight: 600, cursor: "pointer" }}>
            Reset
          </button>
        </div>

        {msg && <p style={{ textAlign: "center", color: "#1f6fd0", fontWeight: 600 }}>{msg}</p>}

        {summary.length > 0 && (
          <div style={{ overflowX: "auto" }}>
            <table style={{ borderCollapse: "collapse", fontSize: "12px", border: "1px solid #14528f", margin: "0 auto" }}>
              <thead>
                <tr style={{ background: "#1f6fd0", color: "#fff" }}>
                  {SUMMARY_COLS.map(([k, h]) => <th key={k} style={th}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {summary.map((r) => (
                  <tr key={r.acNo}>
                    {SUMMARY_COLS.map(([k]) =>
                      k === "__button" ? (
                        <td key={k} style={td}>
                          <button type="button" onClick={() => openDetail(r)}
                            style={{ background: "#fff", border: "1px solid #1f6fd0", color: "#1f6fd0", borderRadius: "6px", padding: "3px 10px", cursor: "pointer", whiteSpace: "nowrap" }}>
                            Booth details
                          </button>
                        </td>
                      ) : (
                        <td key={k} style={td}>{r[k]}</td>
                      )
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {detailAcNo && (
          <div style={{ marginTop: "24px" }}>
            <div style={{ fontWeight: 700, marginBottom: "6px" }}>
              Booth-level details — {detailLabel} {detailLoading ? "(loading...)" : "(" + detailRows.length + " booths)"}
            </div>
            {detailRows.length > 0 && (
              <div style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", fontSize: "12px", border: "1px solid #14528f", minWidth: "1200px" }}>
                  <thead>
                    <tr style={{ background: "#166534", color: "#fff" }}>
                      {DETAIL_COLS.map(([k, h]) => <th key={k} style={{ ...th, border: "1px solid #0f3d22" }}>{h}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {detailRows.map((r) => (
                      <tr key={r.partNo}>
                        {DETAIL_COLS.map(([k]) => <td key={k} style={td}>{r[k]}</td>)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BoothManagerView;
